const add = arr => arr.reduce((a, b) => a + b, 0);

const generateSyntheticData = players => {
  const allPlayersNum = players.length;

  const projs = players.map(x => x.proj);
  const sals = players.map(x => x.salary);

  const maxProj = Math.max(...projs);
  const minProj = Math.min(...projs);
  const maxSalary = Math.max(...sals);
  const minSalary = Math.min(...sals);
  const correl = pearsonCorrelation(projs, sals).toFixed(2);

  const aggSals = add(sals);
  const aggProjs = add(projs);
  const aggValue = ((aggProjs * 1000) / aggSals).toFixed(2);

  return {
    allPlayersNum,
    correl,
    maxProj,
    minProj,
    maxSalary,
    minSalary,
    aggValue
  };
};

const generateValueTitle = (type, { correl, allPlayersNum, aggValue }) =>
  `Cost v. Proj ${type} (${correl} correl, ${allPlayersNum} players, ${aggValue} Value)`;

/**
 *  @fileoverview Pearson correlation score algorithm.
 *  @author matt.west@kojilabs.com (Matt West)
 *  @license Copyright 2013 Matt West.
 *  Licensed under MIT (http://opensource.org/licenses/MIT).
 */

/**
 *  Calculate the person correlation score between two items in a dataset.
 *
 *  @param  {object}  prefs The dataset containing data about both items that
 *                    are being compared.
 *  @param  {string}  p1 Item one for comparison.
 *  @param  {string}  p2 Item two for comparison.
 *  @return {float}  The pearson correlation score.
 */
function pearsonCorrelation(a1, a2) {
  const si = [];

  for (let key in a1) {
    if (a2[key]) si.push(key);
  }

  const n = si.length;
  if (n === 0) return 0;

  let sum1 = 0;
  for (let i = 0; i < si.length; i++) sum1 += a1[si[i]];

  let sum2 = 0;
  for (let i = 0; i < si.length; i++) sum2 += a2[si[i]];

  let sum1Sq = 0;
  for (let i = 0; i < si.length; i++) {
    sum1Sq += Math.pow(a1[si[i]], 2);
  }

  let sum2Sq = 0;
  for (let i = 0; i < si.length; i++) {
    sum2Sq += Math.pow(a2[si[i]], 2);
  }

  let pSum = 0;
  for (let i = 0; i < si.length; i++) {
    pSum += a1[si[i]] * a2[si[i]];
  }

  const num = pSum - (sum1 * sum2) / n;
  const den = Math.sqrt((sum1Sq - Math.pow(sum1, 2) / n) * (sum2Sq - Math.pow(sum2, 2) / n));

  if (den === 0) return 0;

  return num / den;
}

export { generateSyntheticData, generateValueTitle };
